import EventsCta from "../eventsExperiences/EventsCta";
import ctaImage from "../../assets/images/whatwedo/influencer-marketing.jpg";

const POINTS = [
  "Share your goal and budget",
  "Get a free campaign plan within 24 hours",
  "One team from first idea to final report",
];

// Same call-to-action as the Events & Experiences page; the button goes to Contact Us.
const InfluencerCta = () => (
  <EventsCta
    image={ctaImage}
    eyebrow="Start a campaign"
    title="Let's turn your brand into"
    accent="a conversation."
    points={POINTS}
  />
);

export default InfluencerCta;
